import React from 'react';
import { Loader } from '@eika/loader';
const CenteredLoader = _ref => {
  let {
    text
  } = _ref;
  if (text) {
    return /*#__PURE__*/React.createElement("div", {
      className: "centered-loader"
    }, /*#__PURE__*/React.createElement(Loader, null), /*#__PURE__*/React.createElement("p", null, text));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "centered-loader"
  }, /*#__PURE__*/React.createElement(Loader, null));
};
export default CenteredLoader;